import { ContentBox, useBreadcrumbTitle } from "@msuite/ui/app-shell";
import { useTranslation } from "@msuite/ui/localization";
import { Tabs } from "@msuite/ui/tabs";
import { useParams } from "react-router";
import { useArticle } from "@/hooks/use-article";
import { useVendorArticlesList } from "@/hooks/use-vendor-articles-list";
import { ArticleGeneral } from "./article-general";
import { ArticleTransactions } from "./article-transactions";
import { ArticleVendors } from "./article-vendors";
import { ArticleWarehouseLocations } from "./article-warehouse-locations";

export function Article() {
	/** Hooks */
	const articleId = useParams().articleId as string;
	const { t } = useTranslation();
	const { vendorArticles } = useVendorArticlesList(articleId);
	const { article } = useArticle(articleId);
	useBreadcrumbTitle(articleId, article?.name);

	/** Render */
	return (
		<ContentBox>
			<Tabs
				groups={[
					{
						name: "general",
						panels: [
							{
								label: t("general.general"),
								panel: () => <ArticleGeneral articleId={articleId} />,
								cyId: "general-tab",
								errors: [],
							},
						],
					},
					{
						name: "details",
						panels: [
							{
								label: t("stock.warehouse_locations"),
								panel: () => <ArticleWarehouseLocations articleId={articleId} />,
								cyId: "warehouse-locations-tab",
								errors: [],
							},
							{
								label: t("stock.transactions"),
								panel: () => <ArticleTransactions articleId={articleId} />,
								cyId: "transactions-tab",
								errors: [],
							},
							{
								label: t("stock.vendors"),
								panel: () => <ArticleVendors articleId={articleId} />,
								cyId: "vendors-tab",
								errors: !vendorArticles.length ? ["Vendor Articles Needed"] : [],
							},
						],
					},
				]}
			/>
		</ContentBox>
	);
}
